import { CardWrapper } from './Card.styles';

const Card = ({ ...props }) => <CardWrapper {...props} />;

export { Card };
